import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import PropertySearchControl from "../components/PropertySearchcontrol";
import "../components/PropertySearch.css"
import CTA from "../components/cta";

const PAGE_SIZE = 8;

const PropertySearchResult = () => {
  const API =  process.env.REACT_APP_API_URL || "https://nvrealestate.websiteseoonline.com";
  
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  // 🔥 INITIAL FILTERS FROM URL
  const initialFilters = {
    offering_type: query.get("offering_type") || "Sale",
    city: query.get("city") || "",
    property_category: query.get("property_category") || "",
    property_type: query.get("property_type") || "",
    bedrooms: query.get("bedrooms") || "",
    bathrooms: query.get("bathrooms") || "",
    minArea: query.get("minArea") || "",
    maxArea: query.get("maxArea") || "",
    minPrice: query.get("minPrice") || "",
    maxPrice: query.get("maxPrice") || "",
  };

  const [filters, setFilters] = useState(initialFilters);
  const [listings, setListings] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [sortBy, setSortBy] = useState("id DESC");

  const shown = listings.length;

  // 🔥 API fetch
  const fetchListings = async (pageNo = 1, isLoadMore = false, currentFilters = {}) => {
    setLoading(true);
    try {
      const { property_category: propertyCategory, ...otherFilters } = currentFilters;
      const body = {
        page: pageNo,
        pageSize: PAGE_SIZE,
        sortBy: sortBy,
        ...otherFilters,
        ...(propertyCategory ? { property_category: propertyCategory } : {}),
      };

      const res = await fetch(`${API}/api/propertysearch.ashx`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      const result = await res.json();

      if (result.result === 1) {
        setTotal(result.total || 0);
        setListings(prev => (isLoadMore ? [...prev, ...(result.data || [])] : (result.data || [])));
        setHasMore(pageNo * PAGE_SIZE < (result.total || 0));
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // 🔄 INITIAL LOAD OR URL CHANGE
  useEffect(() => {
    fetchListings(1, false, filters);
  }, [location.search, sortBy]); // also refetch if sortBy changes

  // 🔎 SEARCH FROM FILTER BAR
  const handleSearch = (payload) => {
    setFilters(payload);
    setPage(1);
    fetchListings(1, false, payload);

    // update URL
    const queryPayload = { ...payload };
    if (!payload.property_category) delete queryPayload.property_category;
    const queryStr = new URLSearchParams(queryPayload).toString();
    window.history.replaceState(null, "", `/property-search-result?${queryStr}`);
  };

  const handleLoadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchListings(nextPage, true, filters);
  };

  return (
    <> 
       <section
    className="flat-title-page mrg-0 boder-r-0"
    style={{
      backgroundImage:
        "url(images/img/rent-banner.jpg)"
    }}
  >
    <div className="container">
      <div className="breadcrumb-content">
        <h1 className="text-center text-white title">Search Result</h1>
         <div className="container">
        <section
          className="flat-filter-search-v2 flat-section flat-recommended pt-0"
          style={{ marginTop: 2 }}
        > 
        <PropertySearchControl onSearch={handleSearch} defaultValues={filters} />
        </section>
      </div>
      </div>
    </div>
  </section> 
    <div className="property-search-page"> 
      {/* 🏠 PROPERTY LIST */}
      <div className="container">
        <section className="flat-section flat-recommended pt-0">
          <div className="container">
            <div className="box-title-listing">
              <div className="box-left">
                <h3 className="title fw-8">Property Search Result</h3>
                <p>
                  Showing {shown} properties out of {total}
                </p>
              </div>

              <div className="box-filter-tab">
                <select
                  className="nice-select select-filter list-sort"
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                > 
                  <option value="id DESC">Newest</option>
                  <option value="id ASC">Oldest</option>
                  <option value="price ASC">Price: Low → High</option>
                  <option value="price DESC">Price: High → Low</option>
                </select>
              </div>
            </div>

            <div className="row">
              {loading && listings.length === 0 && (
                Array.from({ length: 8 }).map((_, i) => (
                  <div className="col-xl-3 col-lg-6 col-md-6" key={i}>
                    <div className="homelengo-box skeleton">
                      <div className="skeleton-img" />
                      <div className="skeleton-body">
                        <div className="skeleton-line w-80" />
                        <div className="skeleton-line w-60" />
                        <div className="skeleton-line w-40" />
                      </div>
                    </div>
                  </div>
                ))
              )}

              {listings?.map(item => (
                <div className="col-xl-3 col-lg-6 col-md-6" key={item.reference_number}>
                  <div className="homelengo-box">
                    <div className="archive-top">
                      <Link className="images-group" to={`/property/${item.url || ""}/${item.id}`}>
                        <div className="images-style">
                          <img src={item.ImagePath+"/w=365,sharpen=1"} alt={item.title} className="lazyloaded" />
                        </div>
                        <div className="top">
                          <ul className="d-flex gap-6">
                            <li className="flag-tag primary">{item.property_type}</li>
                            <li className="flag-tag style-1">For {item.offering_type}</li>
                          </ul>
                        </div>
                      </Link>
                    </div>

                    <div className="archive-bottom">
                      <div className="content-top">
                        <h6 className="text-capitalize">
                          <Link className="link" to={`/property/${item.url || ""}/${item.id}`}>
                            {item.title}
                          </Link>
                        </h6>
                        <p>{item.sub_community}, {item.community}, {item.city}</p>
                             <ul className="meta-list">
                     {item.rsco === "Residential" && (
    <>
      <li className="item">
        <i className="fa-solid fa-bed" />{" "}
        <strong>
          {Number(item.bedrooms) === 0 ? "Studio" : item.bedrooms}
        </strong>
      </li>

      <li className="item">
        <i className="fa-solid fa-bath" />{" "}
        <strong>{item.No_of_Bathroom}</strong>
      </li>
      <li className="item">
      <i className="fa-solid fa-ruler-combined" />{" "}
      <strong>{Number(item.size).toLocaleString()} SQFT</strong>
    </li>
    </>
  )}

  {item.rsco === "Commercial" && (
    <li className="item">
      <i className="fa-solid fa-ruler-combined" />{" "}
      <strong>{Number(item.size).toLocaleString()} SQFT</strong>
    </li>
  )}
                        </ul>
                        <p className="pt-10">Property ID: {item.reference_number}</p>
                   
                      </div>

                      <div className="content-bottom">
                        <h6 className="price">AED {Number(item.price).toLocaleString()}</h6>
                      </div>
 <div className="listing-card">
  <img src={item.agent_img+"/w=60,sharpen=1"} alt="Agent" className="agent-img" />
  <div className="text-content">
    <div className="listing-by">Listing by</div>
    <div className="agent-name">{item.agent_name}</div>
  </div>
</div>
                      <div className="content-bottom1">
                        <div className="property-icns-w">
                          <Link to={`tel:${item.agent_phone}`}>
                            <i className="icon">
                              <img src="images/img/phone.svg" alt="Call" />
                            </i>
                            Call
                          </Link>
                          <Link
                            to={`https://web.whatsapp.com/send?phone=${item.agent_whatsapp}&text=Hi, I am interested in the listing, ${item.title}, from your website.`}
                            target="_blank"
                          >
                            <i className="icon">
                              <img src="images/img/whatsapp.svg" alt="Whatsapp" />
                            </i>
                            Whatsapp
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* LOAD MORE BUTTON */}
            {hasMore && (
              <div className="text-center mt-4">
                <button className="tf-btn-full btn-line" onClick={handleLoadMore} disabled={loading}>
                  {loading ? "Loading..." : "Load More"}
                </button>
              </div>
            )}
          </div>
        </section>
      </div>
    </div>
    <CTA/>
    </>
  );
};

export default PropertySearchResult;
